import { useState, useEffect, useRef } from "react";
import styles from "./styles.module.css";

const Clima = () => {
  const [weather, setWeather] = useState();
  const [isMounted, setIsMounted] = useState(true);
  const iconUrl = "/img/clima/";
  const url = "/api/clima";
  const [isWeatherData, setIsWeatherData] = useState(true);

  const hoursFormatter = (unixHour) => {
    const date = new Date(unixHour * 1000);

    let hour = date.getHours().toString();
    let minutes = date.getMinutes().toString();
    hour = hour.padStart(2, "0");
    minutes = minutes.padStart(2, "0");

    return `${hour}:${minutes}`;
  };

  const getWeather = async () => {
    try {


      const response = await fetch(url);
      const { data } = await response.json();

      const { sun, moon, forecast } = data;
      forecast.days.splice(0, 1);
      setWeather({
        ...data,
        updatedAt: hoursFormatter(data.updatedAt),
        sun: {
          ...sun,
          rise: hoursFormatter(sun.rise),
          set: hoursFormatter(sun.set),
        },
        moon: {
          ...moon,
          rise: hoursFormatter(moon.rise),
          set: hoursFormatter(moon.set),
        },
        forecast: {
          ...forecast,
          hours: forecast.hours.map((h) => {
            return {
              ...h,
              hour: hoursFormatter(h.hour),
            };
          }),
        },
      });
    } catch (e) {
      console.error('ERROR: falló al obtener información del clima');
      console.error(e);
      setIsWeatherData(false);
    }
  };

  useEffect(() => {
    if (isMounted) {
      getWeather();
    }

    return () => setIsMounted(false);
  }, [isMounted]);

  return (
    <>
      {isWeatherData && <div className={styles['cls-parent']}>
        {weather && (
          <div className={styles["clima-parent"]}>
            <h2 className={styles["subtitle"]}>{weather.name}</h2>
            <div className={styles["clima-container"]}>
              <div className={styles["clima-img"]}>
                <p>
                  {weather.name}: <strong> {weather.conditions}</strong>
                </p>
                <img src={`${iconUrl}${weather.icon.padStart(2, "0")}.png`} alt={weather.conditions} />
              </div>
              <div className={styles["clima-temp"]}>
                <div className={styles["clima-data"]}>
                  <h4>{weather.temp && `${weather.temp}ºC`}</h4>
                  <div className={styles["clima-text"]}>
                    <p>
                      ST: <strong>{weather.feels}ºC</strong> | Hum:{" "}
                      <strong>{weather.humidity}%</strong>
                    </p>
                    <p>
                      Presión Alm.: <strong>{weather.pressure} hPa</strong>
                    </p>
                    <p>
                      Vientos: <strong>{weather.wind} km/h</strong>
                    </p>
                    <p>
                      Visibilidad: <strong>{weather.visibility} km</strong>
                    </p>
                  </div>
                </div>
              </div>
              <ul className={styles["sun-moon"]}>
                <li className={styles["list-item"]}>
                  <h4>Sol</h4>
                  <ul>
                    <li>
                      <p>Salida del sol</p>
                      <strong>{weather.sun.rise} hs</strong>
                    </li>
                    <li>
                      <p>Puesta del sol</p>
                      <strong>{weather.sun.set} hs</strong>
                    </li>
                    <li>
                      <p>Duración</p>
                      <strong>{weather.sun.duration} hs</strong>
                    </li>
                  </ul>
                </li>
                <li className={styles["list-item"]}>
                  <h4>Luna</h4>
                  <ul>
                    <li>
                      <p>Salida de la luna</p>
                      <strong>{weather.moon.rise} hs</strong>
                    </li>
                    <li>
                      <p>Puesta de la luna</p>
                      <strong>{weather.moon.set} hs</strong>
                    </li>
                    <li>
                      <p>Duración</p>
                      <strong>{weather.moon.duration} hs</strong>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <h2 className={styles["subtitle"]}>EXTENDIDO</h2>
            <div className={styles["clima-container"]}>
              {weather.forecast.days && weather.forecast.days.map((d) => (
                <div key={d.day} className={styles["forecast"]}>
                  <h4 className={styles["day"]}>{d.day}</h4>
                  <div className={styles["minmax"]}>
                    <p>Min: {d.min}º C</p>
                    <p>Max: {d.max}º C</p>
                  </div>
                  <ul className={styles["conditions"]}>
                    <li>
                      <h4>Mañana</h4>
                      <p>{d.morning.conditions}</p>
                    </li>
                    <li>
                      <h4>Noche</h4>
                      <p>{d.night.conditions}</p>
                    </li>
                  </ul>

                </div>
              ))}
            </div>
            <h2 className={styles["subtitle"]}>HORA POR HORA</h2>
            <div className={styles["clima-container"]}>
              {weather.forecast.hours && weather.forecast.hours.map((h) => (
                <div key={h.hour} className={styles["forecast"]}>
                  <h4 className={styles["hour"]}>{h.hour}</h4>

                  <div className={styles["temp"]}>
                    <h4>{h.temp}º C</h4>
                    <p>ST: <strong>{h.feel}º C</strong></p>
                  </div>

                  <div className={styles["wind"]}>
                    <h4>Vientos</h4>
                    <p>{h.wind} km/h</p>
                  </div>

                  <div className={styles["hours-conditions"]}>
                    <p>{h.conditions}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>}
    </>
  );
};

export default Clima;
